import _slicedToArray from "/home/appuser/diet.simeonsidieet.ee/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import React, { forwardRef, useState } from 'react';
import { useMantineTheme, Group } from '@mantine/core';
import { useUncontrolled } from '@mantine/hooks';
import dayjs from 'dayjs';
import { isSameDate } from '../../utils/is-same-date/is-same-date.js';
import { isSameMonth } from '../../utils/is-same-month/is-same-month.js';
import { Month } from '../Month/Month.js';
import { CalendarHeader } from '../Calendar/CalendarHeader/CalendarHeader.js';
import { CalendarWrapper } from '../Calendar/CalendarWrapper/CalendarWrapper.js';
import { getDisabledState } from '../Calendar/get-disabled-state/get-disabled-state.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var RangeCalendar = forwardRef(function (_a, ref) {
  var _b = _a,
    classNames = _b.classNames,
    styles = _b.styles,
    locale = _b.locale,
    nextMonthLabel = _b.nextMonthLabel,
    previousMonthLabel = _b.previousMonthLabel,
    initialMonth = _b.initialMonth,
    month = _b.month,
    onMonthChange = _b.onMonthChange,
    value = _b.value,
    onChange = _b.onChange,
    _b$labelFormat = _b.labelFormat,
    labelFormat = _b$labelFormat === void 0 ? "MMMM YYYY" : _b$labelFormat,
    _b$withSelect = _b.withSelect,
    withSelect = _b$withSelect === void 0 ? false : _b$withSelect,
    _b$yearsRange = _b.yearsRange,
    yearsRange = _b$yearsRange === void 0 ? {
      from: 2020,
      to: 2030
    } : _b$yearsRange,
    dayClassName = _b.dayClassName,
    dayStyle = _b.dayStyle,
    disableOutsideEvents = _b.disableOutsideEvents,
    minDate = _b.minDate,
    maxDate = _b.maxDate,
    excludeDate = _b.excludeDate,
    _b$fullWidth = _b.fullWidth,
    fullWidth = _b$fullWidth === void 0 ? false : _b$fullWidth,
    _b$size = _b.size,
    size = _b$size === void 0 ? "sm" : _b$size,
    onMouseLeave = _b.onMouseLeave,
    _b$__staticSelector = _b.__staticSelector,
    __staticSelector = _b$__staticSelector === void 0 ? "range-calendar" : _b$__staticSelector,
    _b$firstDayOfWeek = _b.firstDayOfWeek,
    firstDayOfWeek = _b$firstDayOfWeek === void 0 ? "monday" : _b$firstDayOfWeek,
    _b$allowSingleDateInR = _b.allowSingleDateInRange,
    allowSingleDateInRange = _b$allowSingleDateInR === void 0 ? false : _b$allowSingleDateInR,
    _b$amountOfMonths = _b.amountOfMonths,
    amountOfMonths = _b$amountOfMonths === void 0 ? 1 : _b$amountOfMonths,
    others = __objRest(_b, ["classNames", "styles", "locale", "nextMonthLabel", "previousMonthLabel", "initialMonth", "month", "onMonthChange", "value", "onChange", "labelFormat", "withSelect", "yearsRange", "dayClassName", "dayStyle", "disableOutsideEvents", "minDate", "maxDate", "excludeDate", "fullWidth", "size", "onMouseLeave", "__staticSelector", "firstDayOfWeek", "allowSingleDateInRange", "amountOfMonths"]);
  var theme = useMantineTheme();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    hoveredDay = _useState2[0],
    setHoveredDay = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    pickedDate = _useState4[0],
    setPickedDate = _useState4[1];
  var hasMultipleMonths = amountOfMonths > 1;
  var finalLocale = locale || theme.datesLocale;
  var setRangeDate = function setRangeDate(date) {
    if (pickedDate instanceof Date) {
      if (isSameDate(date, pickedDate) && !allowSingleDateInRange) {
        setPickedDate(null);
        setHoveredDay(null);
        return null;
      }
      var result = [date, pickedDate];
      result.sort(function (a, b) {
        return a.getTime() - b.getTime();
      });
      onChange(result);
      setPickedDate(null);
      return null;
    }
    onChange([null, null]);
    setPickedDate(date);
    return null;
  };
  var handleMouseLeave = function handleMouseLeave(event) {
    typeof onMouseLeave === "function" && onMouseLeave(event);
    setHoveredDay(null);
  };
  var shouldHighlightDate = function shouldHighlightDate(date, modifiers, currentMonth) {
    var isInCurrentMonth = hasMultipleMonths ? isSameMonth(date, currentMonth) : true;
    if (pickedDate instanceof Date && hoveredDay instanceof Date && isInCurrentMonth) {
      var result = [hoveredDay, pickedDate];
      result.sort(function (a, b) {
        return a.getTime() - b.getTime();
      });
      return !modifiers.selected && dayjs(date).subtract(1, "day").isBefore(result[1]) && dayjs(date).add(1, "day").isAfter(result[0]);
    }
    return false;
  };
  var _useUncontrolled = useUncontrolled({
      value: month,
      defaultValue: initialMonth,
      finalValue: new Date(),
      onChange: onMonthChange,
      rule: function rule(val) {
        return val instanceof Date;
      }
    }),
    _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
    _month = _useUncontrolled2[0],
    setMonth = _useUncontrolled2[1];
  var disabledState = getDisabledState({
    month: _month,
    minDate: minDate,
    maxDate: maxDate,
    amountOfMonths: amountOfMonths
  });
  var dayStyles = function dayStyles(date, modifiers, currentMonth) {
    var initialStyles = typeof dayStyle === "function" ? dayStyle(date, modifiers) : null;
    var outsideStyles = modifiers.outside && hasMultipleMonths ? {
      display: "none"
    } : null;
    if (shouldHighlightDate(date, modifiers, currentMonth)) {
      return __spreadProps(__spreadValues(__spreadValues({}, initialStyles), outsideStyles), {
        backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors[theme.primaryColor][9], 0.3) : theme.colors[theme.primaryColor][0],
        borderRadius: 0
      });
    }
    return __spreadValues(__spreadValues({}, initialStyles), outsideStyles);
  };
  return /* @__PURE__ */React.createElement(CalendarWrapper, __spreadValues({
    size: size,
    fullWidth: fullWidth,
    amountOfMonths: amountOfMonths,
    onMouseLeave: handleMouseLeave,
    ref: ref
  }, others), /* @__PURE__ */React.createElement(Group, {
    noWrap: true,
    style: {
      alignItems: "flex-start"
    }
  }, Array(amountOfMonths).fill(0).map(function (_, monthIndex) {
    var isFirstMonth = monthIndex === 0;
    var isLastMonth = monthIndex === amountOfMonths - 1;
    var monthToRender = isFirstMonth ? _month : dayjs(_month).add(monthIndex, "month").toDate();
    var hiddenMonth = isFirstMonth ? "next" : isLastMonth ? "prev" : "both";
    return /* @__PURE__ */React.createElement("div", {
      key: "month-".concat(monthIndex)
    }, /* @__PURE__ */React.createElement(CalendarHeader, {
      size: size,
      nextMonthLabel: nextMonthLabel,
      previousMonthLabel: previousMonthLabel,
      previousMonthDisabled: disabledState.previousDisabled,
      nextMonthDisabled: disabledState.nextDisabled,
      onPreviousMonth: function onPreviousMonth() {
        return setMonth(dayjs(_month).subtract(1, "month").toDate());
      },
      onNextMonth: function onNextMonth() {
        return setMonth(dayjs(_month).add(1, "month").toDate());
      },
      classNames: classNames,
      styles: styles,
      locale: finalLocale,
      withSelect: withSelect,
      yearsRange: yearsRange,
      month: monthToRender,
      setMonth: setMonth,
      labelFormat: labelFormat,
      hiddenMonth: hasMultipleMonths ? hiddenMonth : void 0,
      __staticSelector: isFirstMonth ? __staticSelector : "".concat(__staticSelector, "-month-").concat(monthIndex)
    }), /* @__PURE__ */React.createElement(Month, {
      month: monthToRender,
      range: value,
      value: pickedDate,
      onChange: setRangeDate,
      dayClassName: dayClassName,
      dayStyle: function dayStyle(date, modifiers) {
        return dayStyles(date, modifiers, monthToRender);
      },
      disableOutsideDayStyle: hasMultipleMonths,
      disableOutsideEvents: disableOutsideEvents,
      minDate: minDate,
      maxDate: maxDate,
      excludeDate: excludeDate,
      classNames: classNames,
      styles: styles,
      fullWidth: fullWidth,
      size: size,
      onDayMouseEnter: function onDayMouseEnter(date) {
        return setHoveredDay(date);
      },
      firstDayOfWeek: firstDayOfWeek,
      __staticSelector: isFirstMonth ? __staticSelector : "".concat(__staticSelector, "-month-").concat(monthIndex)
    }));
  })));
});
RangeCalendar.displayName = "@mantine/dates/RangeCalendar";
export { RangeCalendar };